import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ChiSiamoComponent } from './pages/chi-siamo/chi-siamo.component';
import { ProgettoComponent } from './pages/progetto/progetto.component';
import { CorsiComponent } from './pages/corsi/corsi.component';
import { PiattaformaComponent } from './pages/piattaforma/piattaforma.component';
import { ContattiComponent } from './pages/contatti/contatti.component';
import { ErroreComponent } from './pages/errore/errore.component';
import { ScratchComponent } from './pages/corsi/scratch/scratch.component';
import { AppInventorComponent } from './pages/corsi/app-inventor/app-inventor.component';
import { DigitalStorytellingComponent } from './pages/corsi/digital-storytelling/digital-storytelling.component';
import { UnpluggedComponent } from './pages/corsi/unplugged/unplugged.component';
import { RoboticaEducativaComponent } from './pages/corsi/robotica-educativa/robotica-educativa.component';
import { EdSocialMediaComponent } from './pages/corsi/ed-social-media/ed-social-media.component';
import { HtmlCssComponent } from './pages/corsi/html-css/html-css.component';
import { Stampa3dComponent } from './pages/corsi/stampa3d/stampa3d.component';
import { ProgrammazioneDroniComponent } from './pages/corsi/programmazione-droni/programmazione-droni.component';
import { MinecraftComponent } from './pages/corsi/minecraft/minecraft.component';
import { UxUiComponent } from './pages/corsi/ux-ui/ux-ui.component';
import { ArduinoComponent } from './pages/corsi/arduino/arduino.component';
import { LezioniComponent } from './pages/lezioni/lezioni.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'chi-siamo', component: ChiSiamoComponent },
  { path: 'didattica-digitale-per-scuole', component: ProgettoComponent },
  { path: 'corsi-coding', component: CorsiComponent },
  { path: 'piattaforma-di-apprendimento', component: PiattaformaComponent },
  { path: 'coding-a-scuola', component: LezioniComponent },

  { path: 'contatti', component: ContattiComponent },
  // { path: '**', component: ErroreComponent },
  { path: 'corsi/scratch', component: ScratchComponent },
  { path: 'corsi/app-inventor', component: AppInventorComponent },
  {
    path: 'corsi/digital-storytelling',
    component: DigitalStorytellingComponent,
  },
  { path: 'corsi/unplugged', component: UnpluggedComponent },
  { path: 'corsi/robotica-educativa', component: RoboticaEducativaComponent },
  { path: 'corsi/html-css', component: HtmlCssComponent },
  { path: 'corsi/social-media', component: EdSocialMediaComponent },
  { path: 'corsi/arduino', component: ArduinoComponent },
  { path: 'corsi/stampa-3d', component: Stampa3dComponent },
  {
    path: 'corsi/programmazione-droni',
    component: ProgrammazioneDroniComponent,
  },
  { path: 'corsi/minecraft', component: MinecraftComponent },
  { path: 'corsi/ux-ui', component: UxUiComponent },

  { path: '', component: HomeComponent },
  { path: "404", component: ErroreComponent, title: "Pagina non trovata" },
  { path: "**", redirectTo: "404", title: "Pagina non trovata" },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
